// Closed EG-HR relationship list. UI is title case; stored values are snake_case.
// Order matches the source-system acceptable-values list.
export const EMERGENCY_CONTACT_RELATIONSHIP_OPTIONS = [
  { value: 'child', label: 'Child' },
  { value: 'child_in_law', label: 'Child-in-law' },
  { value: 'father', label: 'Father' },
  { value: 'father_in_law', label: 'Father-in-law' },
  { value: 'mother', label: 'Mother' },
  { value: 'mother_in_law', label: 'Mother-in-law' },
  { value: 'other', label: 'Other' },
  { value: 'sibling', label: 'Sibling' },
  { value: 'spouse', label: 'Spouse' },
];

export const EMERGENCY_CONTACT_RELATIONSHIP_VALUES = new Set(
  EMERGENCY_CONTACT_RELATIONSHIP_OPTIONS.map((option) => option.value)
);

export const EMERGENCY_CONTACT_RELATIONSHIP_DISPLAY = {
  spouse: 'Spouse',
  father: 'Father',
  mother: 'Mother',
  sibling: 'Sibling',
  child: 'Child',
  father_in_law: 'Father-in-law',
  mother_in_law: 'Mother-in-law',
  child_in_law: 'Child-in-law',
  other: 'Other',
  // Legacy stored values (pre-remap / awaiting Father vs Mother)
  parent: 'Parent',
  partner: 'Other',
  friend: 'Other',
  relative: 'Other',
};

export function formatEmergencyContactRelationship(value) {
  if (!value) return '';
  const key = String(value).trim().toLowerCase().replace(/[\s-]+/g, '_');
  return EMERGENCY_CONTACT_RELATIONSHIP_DISPLAY[key] || value;
}
